(function($) {
    $.widget("ca.caScheduleGridBlock", {
        options: {
            scheduleId : null,
            eventId : null,
            startTime : null,
            endTime : null,
            date : null,
            serviceId: null,

            resourcesIds : [],
            usersIds : [],

            servicesIds : [],
            addonsIds : [],

            menuItems : {},
            showMenu : false,
            openByClick : false
        },
        _create : function() {
            var self = this;
            var options = self.options;

            if (options.showMenu) {
                self._initMenuItems();
            } else if (options.openByClick) {
                $(self.element).click(self, function(event) {
                    if (event.data.options.openByClick) {
                        $('body').caSpaScheduleManager('manageEvent', event);
                    }
                    return false;
                });
            }
        },
        _initMenuItems : function() {
            var countMenuItems = 0;
            for (var i in this.options.menuItems) {
                countMenuItems++;
            }
            if (countMenuItems == 0) {
                return false;
            }

            var block = this.element;

            block.on('click', function(event) {
                $('.schedule-block-menu').hide();
                $('.time-block').css('z-index', 50);
                $(this).parent().css('z-index', 51);

                var menu = $(this).find('.schedule-block-menu');
                menu.appendTo('.ca-schedule-grid');
                var position = $('.ca-schedule-grid').offset();
                menu.css('left', event.pageX - position.left - 60);
                menu.css('top', event.pageY - position.top);
                menu.css('position', 'absolute');
                menu.show();
            });

            var menu = $('<div class="schedule-block-menu"><div class="menu-triangle"></div><ul></ul></div>').appendTo(block);
            menu.on('mouseleave', function(event) {
                menu.appendTo(block);
                $(this).hide();
            });
            menuUl = menu.find('ul');
            var menuItems = this.options.menuItems;
            
            for (var itemName in menuItems) {
                var item = $('<li><a href="#">'+ itemName +'</a></li>').appendTo(menuUl);

                item.on('click', this, menuItems[itemName]['callback']);
                item.on('click', function() {
                    $(this).closest('.schedule-block-menu').hide();
                });
            }
        }
    });
})(jQuery);